/**
 * Sorts breakpoints
 * @param breakpoints
 * @param order default is "desc"
 * @returns
 */
export function sortBreakpoints(breakpoints, order) {
    if (order === void 0) { order = 'desc'; }
    var sign = order === 'asc' ? -1 : 1;
    var entries = Object.entries(breakpoints);
    var entriesAsObject = entries.map(function (_a) {
        var name = _a[0], width = _a[1];
        return ({ name: name, width: width });
    });
    return entriesAsObject.sort(function (a, b) { return sign * (b.width - a.width); });
}
//# sourceMappingURL=sortBreakpoints.js.map